<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <div>
                    <h5>Asigne preguntas a los puestos</h5>
                    <h5>Preguntas Obligatorias</h5>
                    <!-- datos -->
                    <div >
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="ListPreguntas"
                            [noDataText]="'Sin Datos'"
                            [showColumnHeaders]="true"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxi-column
                            dataField="clave"
                            caption="Clave"
                            alignment="left">
                        </dxi-column>
                            <dxi-column
                                dataField="competencia"
                                caption="Competencia">
                            </dxi-column>
                            <dxi-column
                                dataField="criterio"
                                caption="Criterio">
                            </dxi-column>
                            <dxi-column
                                dataField="pregunta"
                                caption="Pregunta">
                            </dxi-column>
                            <dxi-column
                                dataField="tipopregunta"
                                caption="Tipo de pregunta">
                            </dxi-column>
                            <dxi-column
                                dataField="tipocolaborador"
                                caption="Tipo de colaborador">
                            </dxi-column>
                            <dxi-column
                                dataField="departamento"
                                caption="Departamento">
                            </dxi-column>
                            <dxi-column
                                dataField="nivel"
                                caption="Nivel">
                            </dxi-column>
                        </dx-data-grid>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>